import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

import HeroSection from "./components/HeroSection";
import ValueSection from "./components/ValueSection";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import EventsSection from "./components/EventsSection";
import TradeSection from "./components/TradeSection";
import MembersSection from "./components/MembersSection";
import NewsSection from "./components/NewsSection";
import ActivitySection from "./components/ActivitySection";
import GallerySection from "./components/GallerySection";
import MembershipSection from "./components/MembershipSection";
import ContactSection from "./components/ContactSection";
import { Element } from "react-scroll";
import Seo from "./components/Seo";

export default function Home() {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 400);
    }
  }, []);

  return (
    <div className="relative">
      <Seo
        title="BICCI – Bangladesh Italy Chamber of Commerce and Industry"
        description="BICCI is a bilateral trade platform dedicated to strengthening economic cooperation between Bangladesh and Italy."
        path="/"
        lang="en"
      />
      {/* <Navbar /> */}
      <main>
        <Element name="home">
          <HeroSection />
        </Element>
        <Element name="about">
          <AboutSection />
        </Element>
        <Element name="services">
          <ServicesSection />
        </Element>
        <Element name="trade">
          <TradeSection />
        </Element>
        <Element name="members">
          <MembersSection />
        </Element>
        <Element name="events">
          <EventsSection />
        </Element>
        <Element>
          <NewsSection />
        </Element>
        <Element name="activity">
          <ActivitySection />
        </Element>
        <Element name="gallery">
          <GallerySection />
        </Element>
        <Element name="membership">
          <MembershipSection />
        </Element>
        <Element name="contact">
          <ContactSection />
        </Element>
      </main>
      {/* <Footer /> */}
    </div>
  );
}